import { KYMW1602Component } from "./kymw1602.component";

export class KYMW1602Model {
    KYMW1602Component: KYMW1602Component;
    public goodsImage: string;
}